import create from 'zustand';

const COURSE_PROFILE_INITIAL = {
	course: {
		id: 0,
		title: '',
		titlePublic: '',
		status: '',
		hours: 0,
		slug: '',
		description: '',
		subjectId: 0,
		editable: true
	},
	subject: {
		id: 0,
		title: ''
	},
	exam: {
		id: 0,
		title: '',
		status: ''
	},
	teacher: {
		id: 0,
		avatar: '',
		fullName: '',
		status: '',
		online: false
	},
	webinars: []
};

export const useCourseProfileStore = create(set => ({
	...COURSE_PROFILE_INITIAL,

	// Initialize course's state
	onInit: (course) => set((state) => ({
		course: {
			id: course?.id,
			title: course?.title,
			titlePublic: course?.titlePublic,
			status: course?.status,
			hours: course?.hours,
			slug: course?.slug,
			description: course?.description,
			subjectId: course?.subject?.id,
			editable: course?.editable
		},
		subject: course?.subject ? {
			id: course.subject.id,
			title: course.subject.title
		} : {
			...state.subject
		},
		exam: course?.exam ? {
			id: course.exam.id,
			title: course.exam.title,
			status: course.exam.status
		} : {
			...state.exam
		},
		teacher: course?.teacher ? {
			id: course.teacher.id,
			avatar: course.teacher.avatar,
			fullName: course.teacher.fullName,
			status: course.teacher.status,
			online: course.teacher.online
		} : {
			...state.teacher
		},
		webinars: course.webinars ? course.webinars.map(webinar => ({
			id: webinar.id,
			title: webinar.title,
			eventAt: webinar.eventAt
		})) : state.webinars
	})),

	// Update course's state
	onUpdate: (updated) => set(state => ({
		course: {
			...state.course,
			...updated
		}
	})),

	// Reset store to initial state
	onReset: () => set({
		...COURSE_PROFILE_INITIAL
	})
}));